import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from './input';
import { cn } from '../../lib/utils';
import { INCOMPLETE_MESSAGE_KEY, type DateInputKind } from '../../lib/dateInputs';

type Props = Omit<React.ComponentProps<'input'>, 'type'> & { type?: DateInputKind };

/**
 * `Input` pour les types date / heure natifs, qui DIT quand la saisie est à
 * moitié faite (`validity.badInput`) : bordure rouge et message sous le champ.
 * Voir `lib/dateInputs.ts` pour le refus à l'enregistrement.
 */
const DateTimeInput = React.forwardRef<HTMLInputElement, Props>(
  ({ className, type = 'datetime-local', onChange, onBlur, ...props }, ref) => {
    const { t } = useTranslation();
    const [incomplete, setIncomplete] = React.useState(false);
    return (
      <div className="min-w-0">
        <Input
          ref={ref}
          type={type}
          className={cn(className, incomplete && 'border-destructive focus-visible:ring-destructive')}
          aria-invalid={incomplete || undefined}
          onChange={(e) => { setIncomplete(e.target.validity.badInput); onChange?.(e); }}
          onBlur={(e) => { setIncomplete(e.target.validity.badInput); onBlur?.(e); }}
          {...props}
        />
        {incomplete && (
          <p className="mt-1 text-xs text-destructive">{t(INCOMPLETE_MESSAGE_KEY[type])}</p>
        )}
      </div>
    );
  }
);
DateTimeInput.displayName = 'DateTimeInput';

export { DateTimeInput };
